export default __webpack_public_path__ + "static/media/Flower.0668304c.jpg";